import { Capacity } from '@/features/execute-calculation-set/overmind/calculation/domain/Capacity';

import { AttentionStatus } from '../../../../../AttentionStatus';
import { EvaluationResult } from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class AvailableCapacityEvaluation {
  private readonly ruleName = 'Lv_PowerTransformer_AvailableCapacity';

  constructor(private readonly rulesProvider: ForRuleProviding) {}

  public evaluate(
    availableCapacity: number | undefined | null
  ): EvaluationResult<Capacity> {
    const rule = this.rulesProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(
      rule?.value,
      availableCapacity
    );
    const value = Capacity.from(availableCapacity).toKiloVoltAmpere(); // TODO: remove unit change from evaluation
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
